import tier1Image from "./images/tier_1.png";
import tier2Image from "./images/tier_2.png";
import tier3Image from "./images/tier_3.png";
import tier4Image from "./images/tier_4.png";
import hnwImage from "./images/hnw.png";
import { AccountTier, BFID_URL } from "@bundles/consts";

export type InvestorCardData = {
  tierImage: string;
  additionalImage?: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  disclaimer: string;
  tier: AccountTier;
};

const checkTierStatus = (tier: AccountTier, userTier?: AccountTier, isHNW?: boolean): string => {
  if (!userTier) {
    return '';
  }

  if (tier === AccountTier.Tier_3) {
    return "Coming soon";
  }

  switch (userTier) {
    case AccountTier.Tier_0:
    case AccountTier.Tier_0_KYC:
      if (tier === AccountTier.Tier_1) {
        return "Upgrade to Tier 1";
      }
      if (tier === AccountTier.Tier_2) {
        return "Requires Tier 1";
      }
      if (tier === AccountTier.Tier_4) {
        return "Requires Tier 2";
      }
      break;

    case AccountTier.Tier_1:
    case AccountTier.Tier_1_UK_restricted:
      if (tier === AccountTier.Tier_1) {
        return "Completed";
      }
      if (tier === AccountTier.Tier_2) {
        return "Upgrade to Tier 2";
      }
      if (tier === AccountTier.Tier_4) {
        return "Requires Tier 2";
      }
      break;

    case AccountTier.Tier_2:
      if (tier === AccountTier.Tier_1 || tier === AccountTier.Tier_2) {
        return "Completed";
      }
      if (tier === AccountTier.Tier_4) {
        if (!isHNW) {
          return "Required HNW"
        }

        return "Upgrade to Tier 4";
      }
      break;

    case AccountTier.Tier_4:
      if (tier === AccountTier.Tier_1 || tier === AccountTier.Tier_2 || tier === AccountTier.Tier_4) {
        return "Completed";
      }
      break;

    default:
      return "Invalid tier";
  }

  return "Invalid tier comparison";
};


export const getInvestorCardsData = (userTier?: AccountTier, isHNW?: boolean): InvestorCardData[] => [
  {
    tier: AccountTier.Tier_1,
    tierImage: tier1Image,
    title: "Bitcoin & ETH Staking Investor",
    description:
      "To buy Bitcoin, Stablecoins & Stake ETH, you need to become a client of BF Virtual Assets Ltd. BF Virtual Assets Ltd is a Virtual Assets Service Provider (VASP) based in the British Virgin Islands (BVI) and registered with the BVI Financial Services Commission (BVI FSC).",
    buttonText: checkTierStatus(AccountTier.Tier_1, userTier, isHNW),
    buttonLink: `${BFID_URL}`,
    disclaimer: `As a Tier 1 investor, you'll become a client of BF Virtual Assets Ltd.`,
  },
  {
    tier: AccountTier.Tier_2,
    tierImage: tier2Image,
    title: "Public Shares Investor",
    description:
      "To Invest in Public Shares, you need to become a client of BF Global IB MU Ltd. BF Global IB MU Ltd. is a Securities Broker based in Mauritius, Regulated by the Mauritius Financial Services Commission (MU FSC) as an Investment Dealer (excluding underwriting).",
    buttonText: checkTierStatus(AccountTier.Tier_2, userTier, isHNW),
    buttonLink: `${BFID_URL}/account-type`,
    disclaimer: `As a Tier 2 investor, you'll become a client of BF Global IB MU Ltd.`,
  },
  {
    tier: AccountTier.Tier_3,
    tierImage: tier3Image,
    title: "Private Equity Investor",
    description:
      "To Invest In Public Shares, you need to become a client of BF Global IB MU Ltd. BF Global IB MU Ltd. is a Securities Broker based in Mauritius, Regulated by the Mauritius Financial Services Commission ( MU FSC) as an Investment Dealer (excluding underwriting).",
    buttonText: checkTierStatus(AccountTier.Tier_3, userTier, isHNW),
    buttonLink: `${BFID_URL}`,
    disclaimer: `As a Tier 3 investor, you'll become a client of BF Global IB MU Ltd.`,
  },
  {
    tier: AccountTier.Tier_4,
    tierImage: tier4Image,
    additionalImage: hnwImage,
    title: "Asset Protection HNW Investor",
    description:
      "To invest through an asset protection structure you need to become a client of Bnk To The Future. Bnk To The Future is a securities business based in Cayman Islands, Regulated by the Cayman Islands Monetary Authority (CIMA) as a Securities Investment Business.",
    buttonText: checkTierStatus(AccountTier.Tier_4, userTier, isHNW),
    buttonLink: `${BFID_URL}/account-type`,
    disclaimer: `As a Tier 4 investor, you'll become a client of Bnk To The Future.`,
  },
];

export const tiersRights = {
  [AccountTier.Tier_1]: [AccountTier.Tier_1],
  [AccountTier.Tier_2]: [AccountTier.Tier_1, AccountTier.Tier_2],
  [AccountTier.Tier_3]: [],
  [AccountTier.Tier_4]: [AccountTier.Tier_1, AccountTier.Tier_2, AccountTier.Tier_4],

}
